import _classCallCheck from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { hi as d, fi as l, M as u } from "./abstract-base-8edf0a84-e11d45a3.js";
import { e as p } from "./state-b4c9cc73-ee633f6c.js";
import { a as h } from "./uid-a0afd8c4-59f5d89c.js";
var g = Object.defineProperty,
  m = Object.getOwnPropertyDescriptor,
  n = function n(a, i, o, e) {
    for (var t = e > 1 ? void 0 : e ? m(i, o) : i, r = a.length - 1, s; r >= 0; r--) (s = a[r]) && (t = (e ? s(i, o, t) : s(t)) || t);
    return e && t && g(i, o, t), t;
  };
var f = "beacon-table";
var c = /*#__PURE__*/function (_d) {
  _inherits(c, _d);
  function c() {
    var _this;
    _classCallCheck(this, c);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(c).apply(this, arguments)), _this.isOriginal = !0, _this.uuid = h();
    return _this;
  }
  /** When using transformed cards, this stores all nodes associated with the current one via their identical UUID. */
  _createClass(c, [{
    key: "willUpdate",
    value: function willUpdate(i) {
      var _this2 = this;
      i.forEach(function (o, e) {
        var t;
        _this2.pairedNodes && e !== "isOriginal" && (!_this2.isOriginal && e === "bold" || (t = _this2.pairedNodes) == null || t.forEach(function (r) {
          r[e] = _this2[e];
        }));
      });
    }
  }, {
    key: "pairedNodes",
    get: function get() {
      var i = this.beaconTagName,
        o = this.uuid,
        e = "[uuid=\"".concat(o, "\"]"),
        t = "".concat(this.getScopedTagName(i)).concat(e);
      if (this.isOriginal) {
        var r = this.closest(this.getScopedTagName(f));
        if (!r) return;
        var s = r.transformedCardsContainer;
        return s ? s.querySelectorAll(t) : void 0;
      }
      return document.querySelectorAll(t);
    }
  }]);
  return c;
}(d(l));
n([p()], c.prototype, "isOriginal", 2);
n([u({
  reflect: !0
})], c.prototype, "uuid", 2);
export { c };